"use client"

import { Input } from "@/components/atoms"
import { SearchIcon } from "@/icons"
import { useParams, useRouter, useSearchParams } from "next/navigation"
import { useState } from "react"
import { useTranslate } from "@tolgee/react"

export const NavbarSearch = () => {
  const { t } = useTranslate()
  const router = useRouter()
  const { locale } = useParams()
  const searchParams = useSearchParams()

  const [search, setSearch] = useState(searchParams.get("query") || "")

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const country = String(locale || "")
    const q = search.trim()
    // Must keep /{locale}/ prefix — bare /categories is rewritten by middleware
    // to NEXT_PUBLIC_DEFAULT_REGION (us), dropping China (cn) context.
    const path = q
      ? `/${country}/categories?query=${encodeURIComponent(q)}`
      : `/${country}/categories`
    router.push(path)
  }

  return (
    <form className="flex items-center justify-end w-[166px] min-[1441px]:w-[222px]" method="POST" onSubmit={submitHandler}>
      <div className="w-full">
        <Input
          icon={<SearchIcon />}
          placeholder={t("navbar_search.placeholder")}
          value={search}
          changeValue={setSearch}
          className="h-[38px] py-[9px] rounded-lg border-[#E4E9EE] bg-white"
        />
      </div>
      <input type="submit" className="hidden" />
    </form>
  )
}
